// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"NW-z","sponsoredTooltipWrapper":"OW-z","sponsoredTooltip":"PW-z","newCard":"QW-z"};